import React from "react";
import Signin from '../Signin/Signin';
import Forgotpassword from '../ForgotPassword/Forgotpassword';
import Checkmail from '../Checkmail/Checkmail';
import Setnewpass from '../Setnewpassword/Setnewpass';
import Passwordresetdone from '../PasswordResetDone/Passwordresetdone';
import Entercode from '../Entercode/Entercode';
import Signup from '../Signup/Signup';
import Header from '../../Header/Header';
import LandingpgComponent from '../Landingpage/Landingpage';
import PageNotFound from "../../Common/Component/PageNotFound";
import PrivacyPolicyPage from "../privacyPolicy/PrivacyPolicyPage";
import TermsAndConditionPage from "../privacyPolicy/TermsAndConditionPage";
import DeleteAccountSteps from "../privacyPolicy/DeleteAccountSteps";

const PublicRoutes = [
    {
        path: `/`,
        exact: true,
        component: <LandingpgComponent />
    },
    {
        path: `/LandingpgComponent`,
        exact: true,
        component: <LandingpgComponent />,
    },
    {
        path: `/signin`,
        exact: true,
        component: <Signin />,
    },
    {
        path: `/forgotpassword`,
        exact: true,
        component: <Forgotpassword />,
    },
    {
        path: `/checkmail`,
        exact: true,
        component: <Checkmail />,
    },
    {
        path: `/setnewpass`,
        exact: true,
        component: <Setnewpass />,
    },
    {
        path: `/passresetdone`,
        exact: true,
        component: <Passwordresetdone />,
    },
    {
        path: `/entercode`,
        exact: true,
        component: <Entercode />,
    },
    {
        path: `/signup`,
        exact: true,
        component: <Signup />,
    },
    {
        path: `/header`,
        exact: true,
        component: <Header />,
    },
    {
        path: `/privacy-policy`,
        exact: true,
        component: <PrivacyPolicyPage />,
        // allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" , "ALL"  ],
      },
      {
        path: `/terms-conditions`,
        exact: true,
        component: <TermsAndConditionPage />,
        // allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" , "ALL"  ],
      },

      {
        path: `/delete-account-step`,
        exact: true,
        component: <DeleteAccountSteps />,
        // allowedRoles: ["ADMIN" , "PROVIDER" ,"DOCTOR" , "ALL"  ],
      },
      {
        path: `/delete-account`,
        exact: true,
        component: <DeleteAccountSteps />,
      },
    {
        path: `*`,
        exact: true,
        component: <PageNotFound />,
    },
];
// 
export default PublicRoutes;
